module.exports = __webpack_public_path__ + "static/img/12.61d7fe9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/zh/12.png
// module id = rZNy
// module chunks = 0